import React, { Component } from 'react';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import PropTypes from 'prop-types';
export default class ConditionalLink extends Component {
  static defaultProps = {
    condition: true
  };
  static propTypes = {
    condition: PropTypes.bool
  };

  render() {
    const props = { ...this.props };
    const condition = props.condition;
    delete props.condition;

    return condition ? (
      <Link {...props}>{props.children}</Link>
    ) : (
      <div {...props}>{props.children}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ConditionalLink/ConditionalLink.js